import { useAuthContext } from '../../context/auth/auth'
import { useQuery } from '@tanstack/react-query'
import { Invoice } from '../../interfaces/invoice'
import instance from '../api'

const getSubscriptionInvoices = async (token: string): Promise<Invoice[]> => {
  const response = await instance.get('/payment/payments/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data.data
}

const useSubscriptionInvoices = () => {
  const { token } = useAuthContext()

  return useQuery({
    queryKey: ['subscriptionInvoices'],
    queryFn: () => getSubscriptionInvoices(token!),
  })
}

export default useSubscriptionInvoices
